export function getToday() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return {
    fechaDesde: `${year}-${month}-${day}`,
    fechaHasta: `${year}-${month}-${day}`,
  };
}

export function getThisWeek() {
  const today = new Date();
  const firstDayOfWeek = new Date(
    today.setDate(today.getDate() - today.getDay())
  );
  const lastDayOfWeek = new Date(
    today.setDate(today.getDate() - today.getDay() + 6)
  );
  return {
    fechaDesde: firstDayOfWeek.toISOString().split("T")[0],
    fechaHasta: lastDayOfWeek.toISOString().split("T")[0],
  };
}

export function getThisMonth() {
  const date = new Date();
  const firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    .toISOString()
    .split("T")[0];
  const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    .toISOString()
    .split("T")[0];
  return {
    fechaDesde: firstDay,
    fechaHasta: lastDay,
  };
}

export function getThisQuarter() {
  const date = new Date();
  const quarter = Math.floor(date.getMonth() / 3);
  const firstDay = new Date(date.getFullYear(), quarter * 3, 1)
    .toISOString()
    .split("T")[0];
  const lastDay = new Date(date.getFullYear(), quarter * 3 + 3, 0)
    .toISOString()
    .split("T")[0];
  return {
    fechaDesde: firstDay,
    fechaHasta: lastDay,
  };
}

export function getThisSemester() {
  const date = new Date();
  const semester = Math.floor(date.getMonth() / 6);
  const firstDay = new Date(date.getFullYear(), semester * 6, 1)
    .toISOString()
    .split("T")[0];
  const lastDay = new Date(date.getFullYear(), semester * 6 + 6, 0)
    .toISOString()
    .split("T")[0];
  return {
    fechaDesde: firstDay,
    fechaHasta: lastDay,
  };
}

export function getThisYear() {
  const year = new Date().getFullYear();
  return {
    fechaDesde: `${year}-01-01`,
    fechaHasta: `${year}-12-31`,
  };
}
